/**
 * Two different rules for multi instance steps.
 */

const { is } = require("bpmnlint-utils");

const MI_INSTANCE_COUNT_KEY = "mi.instanceCount";
const MI_SMI_CANCEL_KEY = "mi.smi.cancel";
const MI_PMI_QUORUM_KEY = "mi.pmi.quorum";

function isMultiInstance(node) {
  const bo = node && (node.businessObject || node);
  if (!bo) return false;

  const lc = bo.loopCharacteristics;
  return !!lc && lc.$type === "bpmn:MultiInstanceLoopCharacteristics";
}

function readJsonFromExtra(step, key) {
  if (!step || typeof step !== "object") return undefined;

  const extra = Array.isArray(step.extraParameters) ? step.extraParameters : [];
  const hit = extra.find((p) => p && (p.key === key || p.Key === key));

  const raw = hit && (hit.value ?? hit.Value);
  if (!raw || typeof raw !== "string") return undefined;

  try {
    return JSON.parse(raw);
  } catch {
    return undefined;
  }
}

function getMiInstanceCount(step) {
  const raw = readJsonFromExtra(step, MI_INSTANCE_COUNT_KEY);
  if (!raw || typeof raw !== "object") return null;

  if (raw.kind === "fixed") {
    return typeof raw.value === "number" ? raw.value : null;
  }

  if (raw.kind === "symbol") {
    const sym = raw.value || {};
    const fv = sym.fixedValue ?? sym.value;
    if (fv === undefined || fv === null) return null;

    const n = Number(fv);
    return Number.isFinite(n) ? n : null;
  }

  return null;
}

module.exports = function miInstanceConfig({ ctx }) {
  return {
    check(node, reporter) {
      if (!node) return;

      const isStepLike = is(node, "bpmn:Task") || is(node, "bpmn:UserTask");

      if (!isStepLike || !isMultiInstance(node)) return;

      const getWfSteps = ctx && typeof ctx.getWfSteps === "function" ? ctx.getWfSteps : null;
      const steps = getWfSteps ? getWfSteps() : null;
      if (!Array.isArray(steps) || steps.length === 0) return;

      const step = steps.find((s) => s && s.id === node.id);
      if (!step) return;

      const count = getMiInstanceCount(step);
      if (count === 0) {
        reporter.report(node.id, "Instance Count is 0. This multi-instance step will effectively be a NO-OP.");
      }

      const smiCancel = readJsonFromExtra(step, MI_SMI_CANCEL_KEY);
      const pmiQuorum = readJsonFromExtra(step, MI_PMI_QUORUM_KEY);

      if (!smiCancel && !pmiQuorum) {
        reporter.report(
          node.id,
          "Cancel condition is not defined. If no cancel condition is set, the default cancel condition will be that the number of completed instances equals the number of instances created."
        );
      }
    }
  };
};
